export enum LiveSessionStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum MasterclassLanguage {
  EN = 'en',
  ES = 'es',
  IT = 'it'
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const MasterclassAction = {
  publish: 'publish',
  saveDraft: 'saveDraft',
  unpublish: 'unpublish',
  generic: 'generic'
} as const;

export type MasterclassAction = (typeof MasterclassAction)[keyof typeof MasterclassAction];
